(function ($) {
  Drupal.behaviors.socialShare = {
    attach: function (context, settings) {
      var url = document.documentURI;
      var title = document.title;
      var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(title) + '&amp;via=EsteeLauder';

      $('.ee-social-share__link.twitter').attr('href', twitter_url);

      var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(title);

      $('.ee-social-share__link.facebook').attr('href', facebook_url);

      var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + encodeURI($('.page-main img').first().attr('src')) + '&amp;description=' + encodeURI(title);

      $('.ee-social-share__link.pinterest').attr('href', pinterest_url);

      // If the Discover More block is on the page, it will render before the social share; so let's swap there positions so that the Social Share comes first.
      $('.ee-disco-more + .ee-social-share').insertBefore('.ee-disco-more');

      // simple tooltip reveal on hover
      $('.formatter-estee-edit .ee-social-share').on({
        mouseenter: function () {
          $('.ee-social-share__tooltip').fadeIn(500);
        },
        mouseleave: function () {
          $('.ee-social-share__tooltip').fadeOut(100);
        }
      });
    }
  };
})(jQuery);
